/*
 * Sticky Header
 */
const body = document.body;
const nav = document.querySelector('#main-navigation');
const navSticky = document.querySelector('#nav-sticky');

const stickyHeader = document.getElementById('masthead');
// const adTop = document.querySelector('.ad-fixed-top');
// const lastest = document.querySelector('.container-lastest');
const stickyPreNav = document.querySelector('#masthead .pre-nav');
const scrollUp = 'scroll-up';
const scrollDown = 'scroll-down';
let lastScroll = 0;

window.addEventListener('scroll', function (ev) {
  const scrollTop =
    window.pageYOffset ||
    document.documentElement.scrollTop ||
    document.body.scrollTop ||
    0;
  const currentScroll = window.pageYOffset;
  //const stickyHeader = document.getElementById("masthead");

  //console.log(stickyHeader.offsetHeight);
  //console.log(scrollTop);stickyHeader.offsetHeight

  if (currentScroll == 0) {
    body.classList.remove(scrollUp);
    body.classList.remove(scrollDown);
    return;
  }

  if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
    // down
    body.classList.remove(scrollUp);
    body.classList.add(scrollDown);

    //stickyHeader.style.top = '-' + (stickyPreNav.offsetHeight + 36) + 'px';
  } else if (
    currentScroll < lastScroll &&
    body.classList.contains(scrollDown)
  ) {
    // up
    body.classList.remove(scrollDown);
    body.classList.add(scrollUp);
    //       stickyHeader.style.top=0;
  }
  lastScroll = currentScroll;

  // if (scrollTop > stickyHeader.offsetHeight + adTop.offsetHeight - 20) {


  if (scrollTop > stickyHeader.offsetHeight - 20) {
    nav.classList.add('isSticky');

    //console.log(stickyHeader.offsetHeight);

    document.querySelectorAll('.sticky-header').forEach(stickyHeaderElement => {
      let margin = 0;
      stickyHeaderElement.classList.add('isSticky');
      if (stickyHeaderElement.dataset.stickyMargin) {
        if (stickyHeaderElement.dataset.stickyMargin == '0') {
          margin = 0;
        } else {
          margin = parseInt(stickyHeaderElement.dataset.stickyMargin);
        }
      }
      // console.log(scrollTop + ' ---- ' + stickyHeader.offsetHeight + ' ----- ' + nav.offsetHeight );
      stickyHeaderElement.style.top =  50 + 'px';
      if(stickyHeaderElement.classList.contains("side-iconos-redes")){
        // stickyHeaderElement.style.top = nav.offsetHeight + 110 + 'px';
        stickyHeaderElement.style.top = scrollTop + 200 + 'px';
      }
    });
  } else {


    document.querySelectorAll('.sticky-header').forEach(stickyHeaderElement => {
      stickyHeaderElement.classList.remove('isSticky');
    });
    nav.classList.remove('isSticky');
  }
});


const stickyAds = document.querySelectorAll('.sticky-ad');
const config = {
  root: null,
  rootMargin: '0px 0px 0px',
  threshold: 1,
};

//console.log(stickyAds);

const observer = new IntersectionObserver(function (entries, self) {
  let fixedAd = document.querySelector('.ad-fixed-top');

  entries.forEach(entry => {
    if (entry.isIntersecting) {
      //console.log('Radio', entry.intersectionRatio);

      if (entry.intersectionRatio > 0.9) {
        //console.log('Interseccion', entry);
        //console.log(fixedAd);
        fixedAd.classList.contains('sticky-top')
          ? fixedAd.classList.remove('sticky-top')
          : '';
      }
    }
    // else {
    //   !fixedAd.classList.contains('not-sticky')
    //     ? fixedAd.classList.add('sticky-top')
    //     : '';
    // }
  });
}, config);

stickyAds.forEach(stickyAd => {
  observer.observe(stickyAd);
});
